import { render } from "./shop-all-bags.vue?vue&type=template&id=12c6296f&scoped=true"
import script from "./shop-all-bags.vue?vue&type=script&lang=js"
export * from "./shop-all-bags.vue?vue&type=script&lang=js"

import "./shop-all-bags.vue?vue&type=style&index=0&id=12c6296f&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c6296f"]])

export default __exports__